import 'bootstrap/dist/css/bootstrap.css';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';
import { createBrowserHistory } from 'history';
import configureStore from './store/configureStore';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import ScrollContainer from 'react-indiana-drag-scroll'

// Create browser history to use in the Redux store
const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const history = createBrowserHistory({ basename: baseUrl });

// Get the application-wide store instance, prepopulating with state from the server where available.
const initialState = window.initialReduxState;
const store = configureStore(history, initialState);

const rootElement = document.getElementById('root');
ReactDOM.render(
    <Provider store={store}>
            <ScrollContainer className="scroll-container" horizontal={true} vertical={false} hideScrollbars={false} ignoreElements=".card-draggable-wrapper, .SaleBoard-column, .quick-filter-panel, .MuiFormControl-root">
                <App />
            </ScrollContainer>
    </Provider>,
    rootElement);

registerServiceWorker();
